import _typeof from "@babel/runtime/helpers/typeof";

var _undefined = void 0,
    STATE_PENDING = _undefined,
    STATE_FULFILLED = "fulfilled",
    STATE_REJECTED = "rejected",
    _undefinedString = "undefined",
    soon = function () {
  var e = [],
      t = 1024;
  var n = 0;

  function o() {
    for (; e.length - n;) {
      try {
        e[n]();
      } catch (e) {
        Zousan.error(e);
      }

      e[n++] = _undefined, n == t && (e.splice(0, t), n = 0);
    }
  }

  var s = function () {
    if ("undefined" != typeof MutationObserver) {
      var _e = document.createElement("div");

      return new MutationObserver(o).observe(_e, {
        attributes: !0
      }), function () {
        _e.setAttribute("a", 0);
      };
    }

    return "undefined" != typeof process && "function" == typeof process.nextTick ? function () {
      process.nextTick(o);
    } : "undefined" != typeof setImmediate ? function () {
      setImmediate(o);
    } : function () {
      setTimeout(o, 0);
    };
  }();

  return function (t) {
    e.push(t), e.length - n == 1 && s();
  };
}();

function Zousan(e) {
  if (!(this instanceof Zousan)) throw new TypeError("Zousan must be created with the new keyword");

  if ("function" == typeof e) {
    var t = this;

    try {
      e(function (e) {
        return t.resolve(e);
      }, function (e) {
        return t.reject(e);
      });
    } catch (e) {
      t.reject(e);
    }
  } else if (arguments.length > 0) throw new TypeError("Zousan resolver " + e + " is not a function");
}

function resolveClient(e, t) {
  if ("function" == typeof e.y) try {
    var n = e.y.call(_undefined, t);
    e.p.resolve(n);
  } catch (t) {
    e.p.reject(t);
  } else e.p.resolve(t);
}

function rejectClient(e, t) {
  if ("function" == typeof e.n) try {
    var n = e.n.call(_undefined, t);
    e.p.resolve(n);
  } catch (t) {
    e.p.reject(t);
  } else e.p.reject(t);
}

Zousan.prototype = {
  resolve: function resolve(e) {
    if (this.state !== STATE_PENDING) return;
    if (e === this) return this.reject(new TypeError("Attempt to resolve promise with self"));
    var t = this;

    if (e && ("function" == typeof e || "object" == _typeof(e))) {
      var n = !0;

      try {
        var o = e.then;
        if ("function" == typeof o) return void o.call(e, function (e) {
          n && (n = !1, t.resolve(e));
        }, function (e) {
          n && (n = !1, t.reject(e));
        });
      } catch (e) {
        return void (n && this.reject(e));
      }
    }

    this.state = "fulfilled", this.v = e, t.c && soon(function () {
      for (var _n = 0, _o = t.c.length; _n < _o; _n++) {
        resolveClient(t.c[_n], e);
      }
    });
  },
  reject: function reject(e) {
    if (this.state !== STATE_PENDING) return;
    var t = this;
    this.state = "rejected", this.v = e;
    var n = this.c;
    soon(n ? function () {
      for (var _t = 0, o = n.length; _t < o; _t++) {
        rejectClient(n[_t], e);
      }
    } : function () {
      t.handled || Zousan.suppressUncaughtRejectionError || Zousan.warn("You upset Zousan. Please catch rejections: ", e, e ? e.stack : null);
    });
  },
  then: function then(e, t) {
    var n = new Zousan(),
        o = {
      y: e,
      n: t,
      p: n
    };
    if (this.state === STATE_PENDING) this.c ? this.c.push(o) : this.c = [o];else {
      var _e2 = this.state,
          _t2 = this.v;
      this.handled = !0, soon(function () {
        "fulfilled" === _e2 ? resolveClient(o, _t2) : rejectClient(o, _t2);
      });
    }
    return n;
  },
  catch: function _catch(e) {
    return this.then(null, e);
  },
  finally: function _finally(e) {
    return this.then(e, e);
  },
  timeout: function timeout(e, t) {
    t = t || "Timeout";
    var n = this;
    return new Zousan(function (o, s) {
      setTimeout(function () {
        s(Error(t));
      }, e), n.then(function (e) {
        o(e);
      }, function (e) {
        s(e);
      });
    });
  }
}, Zousan.resolve = function (e) {
  return new Zousan(function (t) {
    return t(e);
  });
}, Zousan.reject = function (e) {
  var t = new Zousan();
  return t.c = [], t.reject(e), t;
}, Zousan.all = function (e) {
  var t = [],
      n = new Zousan();
  var o = 0;

  function s(s, i) {
    s && "function" == typeof s.then || (s = Zousan.resolve(s)), s.then(function (s) {
      t[i] = s, ++o == e.length && n.resolve(t);
    }, function (e) {
      n.reject(e);
    });
  }

  for (var _t3 = 0; _t3 < e.length; _t3++) {
    s(e[_t3], _t3);
  }

  return e.length || n.resolve(t), n;
};

var nop = function nop() {};

Zousan.warn = "undefined" != typeof console ? console.warn : nop, Zousan.error = "undefined" != typeof console ? console.error : nop, Zousan.soon = soon;
export default Zousan;